import type { User } from './signupTypes'

export interface Page {
  id?: number
  siteid?: number
  pagePath?: string
  type?: ContentPageType
  title?: string
  category?: string
  viewCount?: number
  data?: string
  isPublic?: boolean
  createdBy?: User
  createdAt?: string
  updatedBy?: User
  updatedAt?: string
  cards?: Card[]
  imageUrl?: string
}

export interface Card {
  id?: number
  page?: Page
  type?: ContentCardType
  title?: string
  data?: string
  isPublic?: boolean
  order?: number
  createdBy?: User
  createdAt?: string
  updatedBy?: User
  updatedAt?: string
  imageUrl?: string
}

export interface MegaMenu {
  azPages: Page[]
  pagesByCategory: Page[]
  pagesByPopularity: Page[]
}

export enum ContentCardType {
  StandardCard = 0,
  RawHtmlCard = 1,
  LocationCard = 2,
  ListCard = 3,
  ActionCard = 4,
  AboutMeCard = 5,
  Divider = 6
}

export const ContentCardTypes = [
  { value: 0, title: 'Image Card' },
  { value: 1, title: 'WYSIWYG Card' },
  { value: 2, title: 'Location Card' },
  { value: 3, title: 'List Card' },
  { value: 4, title: 'Action Card' },
  { value: 5, title: 'About Me Card' },
  { value: 6, title: 'Divider' }
]

export enum ContentPageType {
  StandardPage = 0,
  RawHtmlPage = 1,
  AboutMePage = 2,
  CardPage = 3
}

export const ContentPageTypes = [
  { value: 0, title: 'Standard Page' },
  { value: 1, title: 'Raw Html Page' },
  { value: 2, title: 'About Me Page' },
  { value: 3, title: 'Card Page' }
]
